import * as T from '@/types'
import moment from 'moment'
import config from '@/config'

export function getLocalTime (utcString: string) {
    return moment.utc(utcString).toDate().toISOString()
}

export const formatAbsoluteDate = (value: string, options?: {
    time?: boolean,
    fullMonth?: boolean,
    showSeconds?: boolean,
}): string => {
    const optionsToUse = {
        time: true,
        fullMonth: false,
        showSeconds: false,
        ...(options || {}),
    }

    const { time, fullMonth, showSeconds } = optionsToUse

    const d = 'Do'

    const m = (() => {
        if (fullMonth) return 'MMMM'
        return 'MMM'
    })()

    const y = 'YYYY'

    const t = (() => {
        if (showSeconds) return 'HH:mm:ss'
        return 'HH:mm'
    })()

    const format = `${d} ${m} ${y}${time ? ` @ ${t}` : ''}`
    
    return moment(getLocalTime(value)).format(format)
}

export const formatShortDate = (value: string, options?: {
    time?: boolean,
    fullMonth?: boolean,
    showSeconds?: boolean,
}): string => {
    
    return moment(getLocalTime(value)).format('DD/MM/YYYY')
}

export const formatShortDateTime = (value: string, options?: {
    time?: boolean,
    fullMonth?: boolean,
    showSeconds?: boolean,
}): string => {
    
    return moment(getLocalTime(value)).format('DD-MM-YYYY HH:mm:ss')
}

export function formatRelativeDate (
    value: string,
    options?: {
        short?: boolean,
        time?: boolean,
        days?: boolean,
    },
): string {
    const date = moment(value)

    if (options && options.short) {
        const diff = moment.duration(moment().diff(date))

        const formatString = (() => {
            if (diff.years() > 0) return 'y[y]'
            if (diff.weeks() > 0) return 'w[w]'
            if (diff.days() > 0) return 'd[d]'
            if (diff.hours() > 0) return 'h[h]'
            if (diff.minutes() > 0) return 'm[m]'
            else return '[now]'
        })()
        
        return moment.duration(moment().diff(date)).format(formatString)
    }
    else if (options && options.time) {
        const fromNow = moment(value).fromNow()
        const time = date.format('HH:mm')
        return `${fromNow} @ ${time}`
    }
    else if (options && options.days) {
        const days = moment(value).diff(moment(), 'days')
        if (days > 1) return `${Math.abs(days)} days from now`
        if (days === 1) return 'Tomorrow'
        if (days === 0) return 'Today'
        if (days === -1) return 'Yesterday'
        return `${Math.abs(days)} days ago`
    }
    else {
        return moment(value).fromNow()
    }
}

export function isReminderValid (payload: { reminderDuration: T.UnixTimestampDelta, secondsUntilDue?: number | null, dueAt?: T.UnixTimestamp | null }) {
    const { reminderDuration, dueAt } = payload

    const secondsUntilDue = payload.secondsUntilDue || (dueAt && moment.unix(dueAt).diff(moment(), 'seconds')) || 0
    const reminderInTheFuture = reminderDuration < secondsUntilDue

    return reminderInTheFuture
}
